import ModelNumberSpecList from '../../components/modelNumberSpecList/ModelNumberSpecList';

const modelNumberSpecList = () => {
  return <ModelNumberSpecList></ModelNumberSpecList>;
};

export default modelNumberSpecList;
